import type { FormEvent } from 'react';

/**
 * Blocks any non-digit `beforeinput` data on a text input. Use on numeric fields
 * to reject typed letters/symbols and pasted non-digit content at the DOM level.
 */
export const digitsOnlyBeforeInput = (e: FormEvent<HTMLInputElement>) => {
  const data = (e.nativeEvent as InputEvent).data;
  if (data != null && !/^\d+$/.test(data)) e.preventDefault();
};

/**
 * Formats a value as a cents-style currency string. Treats input as digits-only;
 * the last two digits are cents. Caps at 9 input digits ($9,999,999.99 max).
 *
 * Examples:
 *   formatCentsInput('1')      → '0.01'
 *   formatCentsInput('100')    → '1.00'
 *   formatCentsInput('1234')   → '12.34'
 *   formatCentsInput('$50.00') → '50.00'
 *   formatCentsInput('')       → ''
 */
export const formatCentsInput = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 9);
  if (!digits) return '';
  const padded = digits.padStart(3, '0');
  const dollars = padded.slice(0, -2).replace(/^0+/, '') || '0';
  const cents = padded.slice(-2);
  return `${dollars}.${cents}`;
};
